import { getCurrentInstance, onBeforeUnmount, ref } from 'vue'

export const useActionCable = ({
  channelName,
  onConnected,
  onReceived,
  onRejected,
  onDisconnected,
}: {
  channelName: string
  onConnected?: () => void
  onReceived?: (data: never) => void
  onRejected?: (error: never) => void
  onDisconnected?: () => void
}) => {
  const instance = getCurrentInstance()
  const cable = instance.proxy.$cable
  const subscribedRoom = ref<string | null>(null)

  const subscribeChannel = (options?: { room: string }) => {
    const room = options?.room ?? ''
    cable.subscribe({ channel: channelName, ...(room.length > 0 && { room }) })
    if (room.length > 0) {
      subscribedRoom.value = room
    }
    cable._addChannel(
      channelName,
      {
        connected: onConnected,
        rejected: onRejected,
        received: onReceived,
        disconnected: onDisconnected,
      },
      {
        _uid: instance.uid,
        _value: instance.proxy,
      },
    )
  }

  const unsubscribeChannel = (options?: { room: string }) => {
    if (options?.room?.length > 0) {
      cable.unsubscribe(channelName, options.room)
    } else {
      cable.unsubscribe(channelName)
    }
  }

  const performAction = ({ action, data }) => {
    cable.perform({
      channel: channelName,
      action,
      data,
    })
  }

  onBeforeUnmount(() => {
    unsubscribeChannel({ room: subscribedRoom.value })
  })

  return {
    subscribeChannel,
    unsubscribeChannel,
    performAction,
  }
}
